import {FactoryBankDetails} from "../types/factory-bank-details-modal.types";

export const defaultFactoryBankDetails: FactoryBankDetails = {
  id: 0,
  organizationName: '',
  inn: '',
  kpp: '',
  bic: '',
  bankName: '',
  settlementAccount: '',
  correspondentAccountNumber: '',
  ogrn: '',
  legalAddress: '',
  actualAddress: '',
  email: '',
  phoneNumber: '',
  comment: ''
}
